import { toast } from 'react-toastify';

const NO_OPEN_PHASE = 'Não há fase disponível para envio de reconhecimentos.';

export type Cycle = { status?: string; date_start?: any; date_finish?: any } | undefined;

/**
 * A fase está aberta quando o ciclo é `open` e a hora do servidor não passou do fim nem está
 * antes do início. Ciclo sem uma das datas não tem esse limite: a comparação com a data
 * ausente é falsa, e a regra sempre foi essa.
 */
export function cycleIsOpenAt(cycle: Cycle, serverTime: number) {
  if (cycle?.status !== 'open') return false;

  return !(serverTime > cycle.date_finish || serverTime < cycle.date_start);
}

export function warnNoOpenPhase() {
  toast.error(NO_OPEN_PHASE, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
